import { ThemeProvider } from "@app/providers/ThemeProvider";
import { AppRouter } from "@app/router";
import { BrowserRouter } from "react-router-dom";
import { ErrorBoundary } from "@app/layout/ErrorBoundary";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { PanelProvider } from "@app/layout/PanelContext";
import { FlowSelectionProvider } from "@features/flows/state/FlowSelectionProvider";
import { NodeSelectionProvider } from "@features/flows/state/NodeSelectionProvider";
import { RunControlProvider } from "@features/flows/state/RunControlProvider";
import { OutputInspectorProvider } from "@features/flows/state/OutputInspectorProvider";
import { AuthProvider } from "@/context/auth";
import { WorkspaceProvider } from "@/context/workspace";
import "../../styles/globals.css";
import { Toaster } from "@/components/ui/sonner";
import RuntimeEventsBridge from "@features/flows/runtime/RuntimeEventsBridge";
import { scan } from "react-scan";

const queryClient = new QueryClient();

if (typeof window !== 'undefined' && import.meta?.env?.DEV) {
  console.log('IMPORT META ENV IS', import.meta.env);
  scan({
    enabled: true,
    log: false,
  });
}

export function App() {
  return (
    <ThemeProvider defaultTheme="dark" storageKey="vite-ui-theme">
      <BrowserRouter>
        <ErrorBoundary>
          <QueryClientProvider client={queryClient}>
            <AuthProvider>
              <WorkspaceProvider>
                <RunControlProvider>
                  <FlowSelectionProvider>
                    <NodeSelectionProvider>
                      <OutputInspectorProvider>
                        <PanelProvider>
                          <>
                            <AppRouter />
                            <RuntimeEventsBridge />
                            <Toaster richColors position="bottom-right" closeButton />
                          </>
                        </PanelProvider>
                      </OutputInspectorProvider>
                    </NodeSelectionProvider>
                  </FlowSelectionProvider>
                </RunControlProvider>
              </WorkspaceProvider>
            </AuthProvider>
          </QueryClientProvider>
        </ErrorBoundary>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
